import React from 'react';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const ZoomControl = _ref => {
  let {
    zoom,
    onZoomChange,
    minZoom = 10,
    maxZoom = 300,
    step = 10
  } = _ref;
  const zoomOptions = [];
  for (let i = minZoom; i <= maxZoom; i += step) {
    zoomOptions.push(i);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      padding: '10px 15px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      zIndex: 1000
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    size: "sm",
    onClick: () => onZoomChange(Math.max(minZoom, zoom - step)),
    disabled: zoom <= minZoom,
    style: {
      padding: '4px 8px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '16px'
    }
  }, "remove")), /*#__PURE__*/React.createElement("select", {
    value: zoom,
    onChange: e => onZoomChange(parseInt(e.target.value)),
    style: {
      border: '1px solid #ddd',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '14px',
      cursor: 'pointer',
      minWidth: '80px'
    }
  }, zoomOptions.map(option => /*#__PURE__*/React.createElement("option", {
    key: option,
    value: option
  }, option, "%"))), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    size: "sm",
    onClick: () => onZoomChange(Math.min(maxZoom, zoom + step)),
    disabled: zoom >= maxZoom,
    style: {
      padding: '4px 8px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '16px'
    }
  }, "add")));
};
export default ZoomControl;